import { z } from "zod";

function isCalendarDate(value: string): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  return parsed.getUTCFullYear() === year
    && parsed.getUTCMonth() === month - 1
    && parsed.getUTCDate() === day;
}

export const dashboardDateSchema = z.object({
  date: z.string().refine(isCalendarDate, "유효한 기준일을 선택해 주세요."),
});

export type DashboardDateFormValues = z.infer<typeof dashboardDateSchema>;

export function parseDashboardDate(value: string | null): string | null {
  const result = dashboardDateSchema.shape.date.safeParse(value);
  return result.success ? result.data : null;
}

export function currentSeoulDate(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}`;
}
